// TODO: We need to come up with a more reliable way for this - it gets 
//  hung up too often.

<template>
    <!--<loading :active.sync="anyPendingRequests" :can-cancel="true" :z-index="9999"></loading>-->
  <loading :can-cancel="true" :z-index="9999"></loading>
</template>

<script>
import { mapGetters } from 'vuex';
import Loading from 'vue-loading-overlay';

export default {
  components: {
    Loading,
  },
  computed: {
    ...mapGetters('global', ['anyPendingRequests']),
  },
};
</script>
